import * as React from 'react';
export default React.createContext({
    onClose: function () { return undefined; },
    testId: '',
});
//# sourceMappingURL=ModalContext.js.map